// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"338e1ce0","952":"ab8220a0"}[chunkId] + ".chunk.js";
};